module.exports = __webpack_public_path__ + "static/media/preview.de14cc4a.png";